module.exports = __webpack_public_path__ + "static/media/event1.6eae9598.jpeg";